module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者特定对象确认，第一步需要投资者做身份认证。投资者需要填写真实的四要输包括姓名、身份证号码、银行卡号、银行预留手机号码、短信验证码（机构填写经办人姓名、经办人身份证号、对公银行账户、银行预留手机号码、短信验证码）\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/confirm2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v("四要素认证")])], 1), _vm._v("\n\t若四要素没通过，需要进行人脸识别，相关信息发送到基金管理人后台审核\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/confirm1.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v("人脸识别")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d193b1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/confirmGuide.vue
// module id = 1034
// module chunks = 1